<template>
  <div>
    <base-crud
      crudName="Configurações de Reserva"
      newText="Nova Configuração de Reserva"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "configurationsTable",
      // pages: [],
      // url: '',
      columns: [
        "id",
        "limit_reservation",
        "time_cancel",
        "t_select_chair",
        "company_id",
        "actions",
      ],
      tableData: [
        "id",
        "limit_reservation",
        "time_cancel",
        "t_select_chair",
        "company_id",
      ],
      options: {
        sortable: ["id", "limit_reservation", "time_cancel", "t_select_chair"],
        filterable: ["id", "limit_reservation", "time_cancel", "company_id"],
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          limit_reservation: "Limite de Reserva",
          time_cancel: "Tempo para cancelamento automático",
          t_select_chair: "Exibir o ícone da cadeira",
          company_id: "Empresa",
          actions: "Ações",
        },
        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "configurations/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        limit_reservation: "limit_reservation",
        time_cancel: "time_cancel",
        select_chair: "select_chair",
        company_id: "company[company_name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Configurations/Crud.vue